export const MAPPING = "Mapping"

export const mappingTabs: readonly MappingTabType[] = ['attribute', 'attributevalue', 'category'] as const;

// Pagination constant for infinite scroll
export const PAGE_SIZE = 40;